<template>
  <b-card bg-variant="light">
    <h3>
      Maintenance switch:
      <span v-if="!current_maintenance_switch" style="color:green">OFF</span>
      <span v-if="current_maintenance_switch" style="color:red">ON</span>
    </h3>
    <template v-if="mayManageMaintenance">
      <b-button v-if="!current_maintenance_switch" @click="submitMaintenance(true)" variant="danger">Enable</b-button>
      <b-button v-if="current_maintenance_switch" @click="submitMaintenance(false)" variant="info">Disable</b-button>
    </template>
  </b-card>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import notifier from '../notifier';
import { mayManageMaintenance as utilMayManageMaintenance } from '../util';

export default {
  name: 'SystemMaintenance',

  data() {
    return {
      actor: auth.getViewer(),
      current_maintenance_switch: false,
    };
  },

  computed: {
    mayManageMaintenance() {
      return utilMayManageMaintenance(this.actor.role);
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);
    this.getCurrentMaintenanceSwitch();
  },

  methods: {
    getCurrentMaintenanceSwitch() {
      HTTP.get('/maintenance_switch')
      .then(response => {
        this.current_maintenance_switch = response.data.maintenance_switch;
       })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },

    submitMaintenance(flag) {
      const data = new FormData();
      data.append('maintenance_switch', flag);

      HTTP.post('/maintenance_switch', data)
      .then(() => {
        this.getCurrentMaintenanceSwitch();
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>
